import React from 'react';
import { Node, Socket, Control } from 'rete-react-render-plugin';

export class MyNode extends Node {
  render() {
    // 1 - destructure variables from props
    const { node, bindSocket, bindControl } = this.props;
    // 2 - destructure variables from state
    const { outputs, controls, inputs, selected } = this.state;

    // 3 - Return the node to canvas
    return (
      <div
        className={`node ${selected}`}
        style={{ backgroundColor: '#b49ee1', borderColor: '#5e35b1' }}
      >
        <div
          className='title'
          style={{ fontSize: '20px', backgroundColor: '#5e35b1' }}
        >
          {node.name}
        </div>
        {/* Outputs */}
        {outputs.map(output => (
          <div className='output' key={output.key}>
            <div className='output-title' style={{ fontSize: '18px' }}>
              {output.name}
            </div>
            <Socket
              type='output'
              socket={output.socket}
              io={output}
              innerRef={bindSocket}
            />
          </div>
        ))}
        {/* Controls */}
        {controls.map(control => (
          <Control
            className='control'
            key={control.key}
            control={control}
            innerRef={bindControl}
          />
        ))}
        {/* Inputs */}
        {inputs.map(input => (
          <div className='input' key={input.key}>
            <Socket
              type='input'
              socket={input.socket}
              io={input}
              innerRef={bindSocket}
            />
            {!input.showControl() && (
              <div className='input-title' style={{ fontSize: '18px' }}>
                {input.name}
              </div>
            )}
            {input.showControl() && (
              <Control
                className='input-control'
                control={input.control}
                innerRef={bindControl}
              />
            )}
          </div>
        ))}
      </div>
    );
  }
}
